export const formatDate = (timestamp) => {
    if (!timestamp) return null;
    let date = timestamp.toDate();
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    return `${day}/${month}/${year}`;
};

export const getDevelopmentPeriodString = (dateStarted, dateCompleted) => {
    if (!dateStarted && !dateCompleted) return "No development period available";
    if (!dateStarted) return "No start date available";

    const start = formatDate(dateStarted);
    if (dateCompleted) {
        const end = formatDate(dateCompleted);
        return `Development Period: ${start} - ${end}`;
    } else {
        return `Started on: ${start} (In Progress)`;
    }
};
